import React, { FC } from 'react';
import { IServiceTransfersDto } from '@shared/api';
import { splitCamelCase } from '@shared/utils';
import { getBooleanValueIcon } from '../utils/getValueIcon';
import classNames from 'classnames';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import { formatTransferData } from '../utils/formatTransferData';
import { TextTooltip } from '@shared/UI';

interface AccountsInfoProps {
    fieldName: string;
    value: string | null;
    className?: string;
    Icon?: React.FC | null;
}

const AccountsInfo: React.FC<AccountsInfoProps> = (props) => {
    const { fieldName, value, className, Icon } = props;

    const longKeys = ['Id', 'External Id', 'File Name', 'Message Id'];
    return (
        <div className={classNames('payment-requests-view-drawer__info-item', className)}>
            <span className='payment-requests-view-drawer__info-header'>{fieldName}:</span>
            <span className={classNames('payment-requests-view-drawer__info-content', value, { nullable: !value })}>
                {Icon && <Icon />}
                {getBooleanValueIcon(value)}{' '}
                {longKeys.includes(String(fieldName)) ? <TextTooltip text={String(value)} /> : value}
            </span>
        </div>
    );
};

const isFinalAcknowledgement = (method: string, level: number) => {
    const finalLevels = {
        ACH: 2,
        Wire: 3,
        Zelle: 3,
    };

    return level === finalLevels[method as keyof typeof finalLevels];
};

export const GeneralTransfer: FC<{ paymentRequest: IServiceTransfersDto }> = ({ paymentRequest }) => {
    return (
        <div>
            {Object.keys(paymentRequest).map((keyName, index) => (
                <AccountsInfo
                    key={index}
                    fieldName={splitCamelCase(keyName, 'every-word')}
                    value={formatTransferData(keyName, paymentRequest) || '-'}
                    Icon={
                        keyName === 'ackLevel' && isFinalAcknowledgement(paymentRequest.method, paymentRequest.ackLevel)
                            ? IoIosCheckmarkCircleOutline
                            : null
                    }
                />
            ))}
        </div>
    );
};
